import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormTermosGerenciamento from '../../components/forms/FormTermosGerenciamento'
import Body from '../../components/layouts/body';


class TermosGerenciamento extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Edição de Termos" subtitulo="Cadastro" descricao="" />
            <Body>               
                <FormTermosGerenciamento />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(TermosGerenciamento));